<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.26 11.75a6.85 6.85 0 0 0 5.69 6.86.63.63 0 0 1 .4.26.65.65 0 0 1-.37 1 .62.62 0 0 1-.25.01A8.14 8.14 0 0 1 4 11.75c0-1.9.85-3.4 1.84-4.53.7-.82 1.52-1.48 2.17-1.98H6.03a.6.6 0 0 1-.43-.18.62.62 0 0 1 0-.88.6.6 0 0 1 .43-.18h3.64a.6.6 0 0 1 .42.18c.12.12.18.27.18.44v3.7c0 .17-.06.33-.18.45a.6.6 0 0 1-.85 0 .62.62 0 0 1-.18-.44V6.05c-.7.53-1.54 1.18-2.28 2.02-.86 1-1.52 2.2-1.52 3.68Zm13.48.5a6.85 6.85 0 0 0-5.6-6.84.63.63 0 0 1-.4-.27.65.65 0 0 1 .4-1 .62.62 0 0 1 .24 0A8.13 8.13 0 0 1 20 12.25c0 1.9-.85 3.4-1.84 4.53A15.2 15.2 0 0 1 16 18.76h1.98a.6.6 0 0 1 .43.18.62.62 0 0 1 0 .88.6.6 0 0 1-.43.18h-3.64a.6.6 0 0 1-.42-.18.62.62 0 0 1-.18-.44v-3.7c0-.17.06-.33.18-.45a.6.6 0 0 1 .85 0c.12.12.18.28.18.44v2.28c.7-.53 1.54-1.18 2.28-2.03.86-.99 1.52-2.2 1.52-3.67Z"
        fill="inherit"
        stroke="none"
      />
    </svg>
  </span>
</template>
